import React from 'react';
import { useSelector } from 'react-redux';
import { selectMarketsMcMenuData } from '../../../slices/markets/selectors/selectMarketsMcMenuData';
import McMenuTable from '../../../components/analyticDashboard/markets/McMenuTable/McMenuTable';
import IUnleashClassFlagProvider from '../../../components/unleash/UnleashClassFlagProvider';
import Constants from '../../../Constants';
import { Text, Card } from '@chakra-ui/react';
// import { ChevronRight } from '../../../shared/Icons';

// This container specifically serves the McMenu Board card.
function McMenu(/* props */) {
  const marketsMcMenuData = useSelector(selectMarketsMcMenuData);

  return (
    <Card.Root>
      <Card.Body>
        <Text textStyle="2xl" style={{ fontWeight: 'normal' }}>
          McMenu Board Index
          <div style={{ display: 'inline-block', width: '18px' }}>{/* <ChevronRight /> */}</div>
        </Text>
        <McMenuTable marketsMcMenuData={marketsMcMenuData} />
      </Card.Body>
    </Card.Root>
  );
}

const McMenuUnleashController = props => {
  return (
    <>
      <IUnleashClassFlagProvider
        flagName={Constants.UNLEASH_FLAG.MARKET_DASHBOARD_MC_MENU}
        show={<McMenu {...props} />}
        hide=""
      />
    </>
  );
};

export default McMenuUnleashController;
